import script from "./MovingNeedle.vue?vue&type=script&setup=true&lang=js"
export * from "./MovingNeedle.vue?vue&type=script&setup=true&lang=js"

import "./MovingNeedle.vue?vue&type=style&index=0&id=4e6eb514&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e6eb514"]])

export default __exports__